import {
  borderRadius,
  SkeletonLoader,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  border: 1px solid var(--border-soft);
  background-color: var(--background-soft);
  ${borderRadius.r2}
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  padding: 16px 16px 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  ${typographyV2.titleMd}
`;

export const LoadingSkeleton = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '96px',
        borderRadius: '8px',
      },
    },
  ],
})`
  padding: 0px 12px 12px 12px;
`;
